enum VertaforeStatuses {
  UNKNWON = 'UNKNOWN',
  NO_UPLOADING = 'NO_UPLOADING',
  NOT_UPLOADED = 'NOT_UPLOADED',
  UNSIGNED_UPLOADED = 'UNSIGNED_UPLOADED',
  SIGNED_UPLOADED = 'SIGNED_UPLOADED',
  ERROR_CREATE_CLIENT = 'ERROR_CREATE_CLIENT',
  ERROR_UPLOAD_DOCUMENT = 'ERROR_UPLOAD_DOCUMENT',
  ERROR_CREATE_POLICY = 'ERROR_CREATE_POLICY',
}

export default VertaforeStatuses;
export type VerifyVertaforeStatuses = Utils.VerifyExtends<
  Model.Enum.VertaforeStatuses,
  Utils.ValueOf<typeof VertaforeStatuses>
>;
